import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import templateApi from '../../APIs/template';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Typography,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { humanReadableDateWithTime, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import {
  DownloadTemplateContainerStyled,
  DownloadTemplateTableStyled,
} from './style';

type ParamsType = {
  page: number;
  limit: number;
};

const DownloadTemplate = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();

  const templateData = useSelector((state: RootState) => state.templates.data);
  const pagination = useSelector(
    (state: RootState) => state.templates.pagination
  );

  const getTemplateData = async (params: MyParamsType) => {
    try {
      await requestAPI(
        templateApi.getAllTemplate({
          page: params.page,
          limit: params.limit,
          search: params.search ? params.search : '',
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTemplateData(pagination);
  }, []);

  const formattedTableData = templateData.map((template) => ({
    id: `${template?._id}`,
    date: humanReadableDateWithTime(template?.createdAt),
    templeteTitle: template?.templateTitle,
    templeteCountry: (
      <div>
        <span>{template?.country[0]}</span>
      </div>
    ),
    templeteFile: (
      <div className="templeteFile">
        <img
          src={template?.uploadTemplate[0]}
          alt="Templete"
          className="templeteFileImage"
        />
      </div>
    ),
    actions: (
      <Button
        variant="secondary"
        onClick={() => navigate(`/downloads-template/${template?._id}`)}
        style={{
          backgroundColor: theme.colors.blueLight,
          border: `1px solid ${theme.colors.blueLight}`,
        }}
      >
        View Details
      </Button>
    ),
  }));
  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Created Date' },
      { key: 'templeteTitle', label: 'Templete Title' },
      { key: 'templeteCountry', label: 'Templete Country' },
      { key: 'templeteFile', label: 'templete File' },
      { key: 'actions', label: 'Actions' },
    ],
    body: formattedTableData,
  };
  const debouncedFunction = useCallback(
    debounce((myParams) => getTemplateData(myParams), 500),
    []
  );

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  const handlePagination = (updatedParams: ParamsType) => {
    getTemplateData(updatedParams);
    dispatch(Store.Actions.update('templates.pagination', updatedParams));
  };

  return (
    <DownloadTemplateContainerStyled>
      <Typography variant="title" style={{ marginBottom: '24px' }}>
        Escape plan offers a diverse selection of downloadable shapes for your
        use.
      </Typography>
      <PageHeader
        pageTitle={<Typography variant="title">Template File</Typography>}
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />

      <DownloadTemplateTableStyled>
        <div className="table-container">
          <Table tableData={tableData} maxWidthForCardView="800px" />
        </div>
        <Pagination
          activePage={pagination.page}
          handlePagination={handlePagination}
          limit={pagination.limit}
          totalCount={pagination.totalData || 0}
        />
      </DownloadTemplateTableStyled>
    </DownloadTemplateContainerStyled>
  );
};

export default DownloadTemplate;
